import React from "react";
import { cn } from "@/lib/utils";

const variantClass = {
    success: "badge-success",
    warning: "badge-warning",
    error: "badge-error",
    info: "badge-info",
    neutral: "badge-neutral",
    copper: "badge-copper",
};

export const NxBadge = ({ children, variant = "neutral", className = "", testId, ...rest }) => (
    <span
        className={cn("badge", variantClass[variant] || variantClass.neutral, className)}
        data-testid={testId}
        {...rest}
    >
        {children}
    </span>
);
